import { useRef } from "react"
import { Dayjs } from "dayjs"
import styled from "styled-components"

import { useOutsideClick } from "utils/useOutsideClick"
import DateWithSelectTimePicker from "components/common/DateWithSelectTimePicker.tsx/DateWithSelectTimePicker"

const Container = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column-reverse;
  align-items: flex-start;
  justify-content: flex-end;
  border-radius: 8px;
  width: 290px;
  height: 440px;
  bottom: 30px;
  left: 200px;
  background-color: #fff;
  z-index: 10;
  box-shadow:
    0 6px 16px 0 rgba(0, 0, 0, 0.08),
    0 3px 6px -4px rgba(0, 0, 0, 0.12),
    0 9px 28px 8px rgba(0, 0, 0, 0.05);

  @media only screen and (max-width: 520px) {
    left: auto;
  }
`

const Description = styled.div`
  color: #64748b;
  padding: 0 18px;
  font-size: 12px;
  order: -1;
`

interface PerformanceTestDateTimePickerModalProps {
  onCancel: () => void
  selectedDateTime: Dayjs | null
  onDateTimeChange: (dateTime: Dayjs) => void
}

const PerformanceTestDateTimePickerModal = ({
  onCancel,
  selectedDateTime,
  onDateTimeChange,
}: PerformanceTestDateTimePickerModalProps) => {
  const container = useRef<HTMLDivElement>(null)

  useOutsideClick(container, () => onCancel(), true)

  return (
    <Container ref={container}>
      <DateWithSelectTimePicker onDateTimeChange={onDateTimeChange} />
      <Description>
        The Performance test will be activated on selected device(s) based on their local time{" "}
        {selectedDateTime ? `at ${selectedDateTime.format("MMM DD, YYYY hh:mma")}` : ""}
      </Description>
    </Container>
  )
}

export default PerformanceTestDateTimePickerModal
